import client from './apiClient';

function changePassword(currentPassword, newPassword) {
  return client('portaluserproperties', {
    body: {
      currentPassword: currentPassword,
      newPassword: newPassword,
    },
    method: 'PUT',
  });
}
export { changePassword };
